import {Component, EventEmitter, OnInit, Output, inject} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule} from '@angular/forms';
import {StandardSubjectFormComponent} from '../standard-subject-form.component';
import {dateValidator} from '../../../../_utils/validators';
import {ConsumerSubjectFormComponent} from '../consumer-subject-form/consumer-subject-form.component';
import {ADDRESS_PATTERN, FOUR_DIGITS_PATTERN, POSTAL_PATTERN} from '../../../../_constants/constants';
import {NgClass} from '@angular/common';
import {HideOnBlurDirective} from '../../../../_directives/hide-on-blur.directive';
import {NgxMaskModule} from 'ngx-mask';
import {ValidationErrorsComponent as ValidationErrorsComponent_1} from '../../../../common/forms/validation-errors/validation-errors.component';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-aml-subject-form',
    templateUrl: './aml-subject-form.component.html',
    styleUrls: ['./aml-subject-form.component.scss'],
    imports: [StandardSubjectFormComponent, ReactiveFormsModule, NgClass, HideOnBlurDirective, NgxMaskModule, ValidationErrorsComponent_1, TranslateModule]
})
export class AmlSubjectFormComponent implements OnInit {

  @Output() submittedData: EventEmitter<UntypedFormGroup> = new EventEmitter<UntypedFormGroup>();
  @Output() back: EventEmitter<void> = new EventEmitter<void>();

  /**
   * This gets passed to the nested validation-error components.
   *
   * @see {@link ValidationErrorsComponent.displayErrors}
   */
  displayErrors: boolean = false;

  subjectFormGroup: UntypedFormGroup;
  identificationFormGroup: UntypedFormGroup;
  addressFormGroup: UntypedFormGroup;
  private formBuilder = inject(UntypedFormBuilder);

  constructor() {
    const formBuilder = this.formBuilder;

    this.subjectFormGroup = ConsumerSubjectFormComponent.buildConsumerSubjectFormGroup(formBuilder);
    this.identificationFormGroup = this.formBuilder.group({
      sin: ['', Validators.pattern(FOUR_DIGITS_PATTERN)],
      dob: ['', dateValidator]
    });
    this.addressFormGroup = AmlSubjectFormComponent.buildAmlAddressFormGroup(this.formBuilder);
  }

  static buildAmlAddressFormGroup(formBuilder: UntypedFormBuilder) {
    return StandardSubjectFormComponent.buildAddressFormGroup(formBuilder, {
      streetNum:  '',
      apartmentNum: ''
    });
  }

  ngOnInit(): void {
  }

}
